"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var hierarchy_exports = {};
__export(hierarchy_exports, {
  Hierarchy: () => Hierarchy
});
module.exports = __toCommonJS(hierarchy_exports);
var import_classes = require("./classes");
var import_clone = require("./clone");
var import_component = __toESM(require("./component"));
var import_proxy = require("./proxy");
var import_tx = require("./tx");
class Hierarchy {
  /** Shared system hierarchy this one extends: own entries win, the rest is read from it. */
  constructor(parent) {
    this.parent = parent;
  }
  static {
    __name(this, "Hierarchy");
  }
  classifiers = /* @__PURE__ */ new Map();
  attributes = /* @__PURE__ */ new Map();
  attributesById = /* @__PURE__ */ new Map();
  // Derived on demand: a class may be created before its parent, and an eagerly derived
  // chain would stay truncated forever.
  descendants = /* @__PURE__ */ new Map();
  ancestors = /* @__PURE__ */ new Map();
  // Instances owned by ModelDb: it applies their updates, doing it here too would double $push/$inc.
  externallyOwned = /* @__PURE__ */ new Set();
  // Classifiers and attributes of the shared parent hidden here: the parent itself stays untouched.
  removed = /* @__PURE__ */ new Set();
  inheritedDomains = /* @__PURE__ */ new Map();
  // A parent classifier re-created/updated/removed here may have changed the parent's descendant lists.
  parentOverridden = false;
  findClassifier(_id) {
    const own = this.classifiers.get(_id);
    if (own !== void 0) return own;
    return this.removed.has(_id) ? void 0 : this.parent?.findClassifier(_id);
  }
  hasClassifier(_id) {
    if (this.classifiers.has(_id)) return true;
    return this.removed.has(_id) ? false : this.parent?.hasClassifier(_id) ?? false;
  }
  classifierIds() {
    if (this.parent === void 0) {
      return this.classifiers.keys();
    }
    const ids = /* @__PURE__ */ new Set();
    for (const _id of this.parent.classifierIds()) {
      if (!this.removed.has(_id)) ids.add(_id);
    }
    for (const _id of this.classifiers.keys()) {
      ids.add(_id);
    }
    return ids.values();
  }
  /** Own map of a class is complete (parent's entries copied in on first write), so no merge per call. */
  ownAttributesOf(_class) {
    return this.attributes.get(_class) ?? this.parent?.ownAttributesOf(_class);
  }
  ownAttributeMap(_class) {
    let attributes = this.attributes.get(_class);
    if (attributes === void 0) {
      attributes = new Map(this.parent?.ownAttributesOf(_class));
      this.attributes.set(_class, attributes);
    }
    return attributes;
  }
  findAttributeById(_id) {
    const own = this.attributesById.get(_id);
    if (own !== void 0) return own;
    return this.removed.has(_id) ? void 0 : this.parent?.findAttributeById(_id);
  }
  /** Copy-on-write: an attribute owned by the shared parent must not be mutated in place. */
  ownAttribute(_id) {
    const own = this.attributesById.get(_id);
    if (own !== void 0) return own;
    const inherited = this.findAttributeById(_id);
    if (inherited === void 0) return void 0;
    const copy = (0, import_clone.clone)(inherited);
    this.addAttribute(copy);
    return copy;
  }
  /** Copy-on-write: a classifier owned by the shared parent must not be mutated in place. */
  ownClassifier(_id) {
    const own = this.classifiers.get(_id);
    if (own !== void 0) return own;
    const inherited = this.findClassifier(_id);
    if (inherited === void 0) return void 0;
    const copy = (0, import_clone.clone)(inherited);
    this.classifiers.set(_id, copy);
    this.invalidateChains();
    return copy;
  }
  proxies = /* @__PURE__ */ new Map();
  classifierProperties = /* @__PURE__ */ new Map();
  createMixinProxyHandler(mixin) {
    const value = this.getClass(mixin);
    const ancestor = this.getClass(value.extends);
    const ancestorProxy = ancestor.kind === import_classes.ClassifierKind.MIXIN ? this.getMixinProxyHandler(ancestor._id) : null;
    return (0, import_proxy._createMixinProxy)(value, ancestorProxy);
  }
  getMixinProxyHandler(mixin) {
    const handler = this.proxies.get(mixin);
    if (handler === void 0) {
      const handler2 = this.createMixinProxyHandler(mixin);
      this.proxies.set(mixin, handler2);
      return handler2;
    }
    return handler;
  }
  /**
   * Proxy get-invariant: a frozen own property must be returned as is, so a mixin value may not
   * shadow a root key of the same name. Only such a collision forces an unfrozen copy.
   */
  shadowsFrozenKey(target, mixin) {
    for (const _class of this.getAncestors(mixin)) {
      const value = target[_class];
      if (typeof value !== "object" || value === null) continue;
      for (const key in value) {
        if (key in target) return true;
      }
    }
    return false;
  }
  as(doc, mixin) {
    if (doc[import_proxy.PROXY_MIXIN_CLASS_KEY] === mixin) return doc;
    const handler = this.getMixinProxyHandler(mixin);
    const target = Hierarchy.toDoc(doc);
    const copy = Object.isFrozen(target) && this.shadowsFrozenKey(target, mixin);
    return new Proxy(copy ? { ...target } : target, handler);
  }
  asIf(doc, mixin) {
    if (doc === void 0) {
      return void 0;
    }
    return this.hasMixin(doc, mixin) ? this.as(doc, mixin) : void 0;
  }
  asIfArray(docs, mixin) {
    return docs.map((it) => this.asIf(it, mixin)).filter((it) => it !== void 0);
  }
  static toDoc(doc) {
    return (0, import_proxy._toDoc)(doc);
  }
  static mixinClass(doc) {
    return (0, import_proxy._mixinClass)(doc);
  }
  static mixinOrClass(doc) {
    const m = (0, import_proxy._mixinClass)(doc);
    return m ?? doc._class;
  }
  static hasMixin(doc, mixin) {
    const d = Hierarchy.toDoc(doc);
    return typeof d[mixin] === "object";
  }
  hasMixin(doc, mixin) {
    return Hierarchy.hasMixin(doc, mixin);
  }
  // M is a mixin on the class, not on the document, so it is not bound to D: mixins such as
  // ObjectPresenter extend Class<Doc>, which never extends the document type D.
  classHierarchyMixin(_class, mixin, filter) {
    let clazz = this.getClass(_class);
    while (true) {
      if (this.hasMixin(clazz, mixin)) {
        const m = this.as(clazz, mixin);
        if (m !== void 0 && (filter?.(m) ?? true)) {
          return m;
        }
      }
      if (clazz.extends === void 0) return;
      clazz = this.getClass(clazz.extends);
    }
  }
  findClassOrMixinMixin(doc, mixin) {
    const cc = this.classHierarchyMixin(doc._class, mixin);
    if (cc !== void 0) {
      return cc;
    }
    const _doc = (0, import_proxy._toDoc)(doc);
    for (const [k, v] of Object.entries(_doc)) {
      if (typeof v === "object" && this.hasClassifier(k)) {
        const cc2 = this.classHierarchyMixin(k, mixin);
        if (cc2 !== void 0) {
          return cc2;
        }
      }
    }
  }
  findMixinMixins(doc, mixin) {
    const _doc = (0, import_proxy._toDoc)(doc);
    const result = [];
    const resultSet = /* @__PURE__ */ new Set();
    for (const [k, v] of Object.entries(_doc)) {
      if (typeof v === "object" && this.hasClassifier(k)) {
        const clazz = this.getClass(k);
        if (this.hasMixin(clazz, mixin)) {
          const cc = this.as(clazz, mixin);
          if (cc !== void 0 && !resultSet.has(cc._id)) {
            result.push(cc);
            resultSet.add(cc._id);
          }
        }
      }
    }
    return result;
  }
  findAllMixins(doc) {
    const _doc = (0, import_proxy._toDoc)(doc);
    const resultSet = /* @__PURE__ */ new Set();
    for (const [k, v] of Object.entries(_doc)) {
      if (typeof v === "object" && this.hasClassifier(k)) {
        if (this.isMixin(k)) {
          if (!resultSet.has(k)) {
            resultSet.add(k);
          }
        }
      }
    }
    return Array.from(resultSet);
  }
  getAllPossibleMixins(_class, to = import_component.default.class.Doc) {
    const result = /* @__PURE__ */ new Set();
    let c = this.getClass(_class);
    while (c._id !== to && c.extends !== void 0) {
      const _descendants = this.getDescendants(c._id);
      for (const d of _descendants) {
        if (this.isMixin(d) && this.getBaseClass(d) === c._id) {
          result.add(d);
        }
      }
      c = this.getClass(c.extends);
    }
    return [...result];
  }
  isMixin(_class) {
    const data = this.findClassifier(_class);
    return data !== void 0 && this._isMixin(data);
  }
  getAncestors(_class) {
    const cached = this.ancestors.get(_class);
    if (cached !== void 0) {
      return cached;
    }
    if (!this.hasClassifier(_class)) {
      throw new Error("ancestors not found: " + _class);
    }
    let result = this.classifiers.has(_class) ? void 0 : this.parent?.getAncestors(_class);
    if (result?.some((id) => this.classifiers.has(id) || this.removed.has(id)) === true) {
      result = void 0;
    }
    result ??= this.buildAncestors(_class);
    this.ancestors.set(_class, result);
    return result;
  }
  buildAncestors(_class) {
    const cl = [_class];
    const visited = /* @__PURE__ */ new Set();
    const ancestorList = [];
    while (cl.length > 0) {
      const classifier = cl.shift();
      if (addNew(visited, classifier)) {
        ancestorList.push(classifier);
        cl.push(...this.ancestorsOf(classifier));
      }
    }
    return ancestorList;
  }
  invalidateChains() {
    this.ancestors.clear();
    this.descendants.clear();
    this.inheritedDomains.clear();
  }
  getClass(_class) {
    const data = this.findClassifier(_class);
    if (data === void 0 || this.isInterface(data)) {
      throw new Error("class not found: " + _class);
    }
    return data;
  }
  findClass(_class) {
    const data = this.findClassifier(_class);
    if (data === void 0 || this.isInterface(data)) {
      return void 0;
    }
    return data;
  }
  hasClass(_class) {
    const data = this.findClassifier(_class);
    return !(data === void 0 || this.isInterface(data));
  }
  getClassOrInterface(_class) {
    const data = this.findClassifier(_class);
    if (data === void 0) {
      throw new Error("class not found: " + _class);
    }
    return data;
  }
  getInterface(_interface) {
    const data = this.findClassifier(_interface);
    if (data === void 0 || !this.isInterface(data)) {
      throw new Error("interface not found: " + _interface);
    }
    return data;
  }
  getDomain(_class) {
    const domain = this.findDomain(_class);
    if (domain === void 0) {
      throw new Error(`domain not found: ${_class} `);
    }
    return domain;
  }
  findDomain(_class) {
    const klazz = this.findClass(_class);
    if (klazz === void 0) return;
    if (klazz.domain !== void 0) {
      return klazz.domain;
    }
    const cached = this.inheritedDomains.get(_class);
    if (cached !== void 0) {
      return cached;
    }
    if (this.parent !== void 0 && !this.classifiers.has(_class) && this.getAncestors(_class) === this.parent.getAncestors(_class)) {
      return this.parent.findDomain(_class);
    }
    let _klazz = klazz;
    while (_klazz.extends !== void 0) {
      _klazz = this.findClass(_klazz.extends);
      if (_klazz === void 0) return;
      if (_klazz.domain !== void 0) {
        this.inheritedDomains.set(_class, _klazz.domain);
        return _klazz.domain;
      }
    }
  }
  getMixinClasses(mixin) {
    const result = [];
    for (const _id of this.classifierIds()) {
      try {
        if (this.classHierarchyMixin(_id, mixin) !== void 0) {
          result.push(_id);
        }
      } catch (e) {
      }
    }
    return result;
  }
  /**
   * `doc` hands over an instance owned by the caller (ModelDb): it is referenced, not copied,
   * and its updates are left to the owner. Without `doc` the hierarchy owns its documents.
   */
  tx(tx, doc) {
    switch (tx._class) {
      case import_component.default.class.TxCreateDoc:
        this.txCreateDoc(tx, doc);
        return;
      case import_component.default.class.TxUpdateDoc:
        this.txUpdateDoc(tx);
        return;
      case import_component.default.class.TxRemoveDoc:
        this.txRemoveDoc(tx);
        return;
      case import_component.default.class.TxMixin:
        this.txMixin(tx);
    }
  }
  /** Point classifier/attribute indexes at a new instance of a document its owner replaced. */
  replaceDoc(doc) {
    if (this.hasClassifier(doc._id)) {
      this.classifiers.set(doc._id, doc);
      this.classifierProperties.delete(doc._id);
      this.externallyOwned.add(doc._id);
    } else if (this.findAttributeById(doc._id) !== void 0) {
      this.addAttribute(doc);
      this.externallyOwned.add(doc._id);
    }
  }
  isClassifierTx(tx) {
    return CLASSIFIER_CLASSES.includes(tx.objectClass) || this.isDerived(tx.objectClass, import_component.default.class.Class);
  }
  txCreateDoc(tx, doc) {
    const isClassifier = this.isClassifierTx(tx);
    if (!isClassifier && tx.objectClass !== import_component.default.class.Attribute) return;
    if (doc !== void 0) this.externallyOwned.add(tx.objectId);
    else this.externallyOwned.delete(tx.objectId);
    this.removed.delete(tx.objectId);
    if (isClassifier) {
      const _id = tx.objectId;
      if (this.parent?.hasClassifier(_id) === true) this.parentOverridden = true;
      this.classifiers.set(_id, doc ?? import_tx.TxProcessor.createDoc2Doc(tx));
      this.invalidateChains();
    } else {
      const createTx = tx;
      this.addAttribute(doc ?? import_tx.TxProcessor.createDoc2Doc(createTx));
    }
  }
  txUpdateDoc(tx) {
    if (tx.objectClass === import_component.default.class.Attribute) {
      const updateTx = tx;
      const doc = this.ownAttribute(updateTx.objectId);
      if (doc === void 0) return;
      if (!this.externallyOwned.has(doc._id)) {
        import_tx.TxProcessor.updateDoc2Doc(doc, updateTx);
      }
      this.addAttribute(doc);
      const map = this.ownAttributeMap(doc.attributeOf);
      for (const [name, attr] of map) {
        if (name !== doc.name && attr._id === doc._id) {
          const inherited = this.parent?.ownAttributesOf(doc.attributeOf)?.get(name);
          if (inherited !== void 0 && inherited._id !== doc._id && !this.removed.has(inherited._id)) {
            map.set(name, inherited);
          } else {
            map.delete(name);
          }
        }
      }
      this.classifierProperties.delete(doc.attributeOf);
    } else if (this.isClassifierTx(tx)) {
      const updateTx = tx;
      const doc = this.ownClassifier(updateTx.objectId);
      if (doc === void 0) return;
      if (!this.externallyOwned.has(doc._id)) {
        import_tx.TxProcessor.updateDoc2Doc(doc, updateTx);
      }
      this.classifierProperties.delete(doc._id);
      if (this.parent?.hasClassifier(doc._id) === true) this.parentOverridden = true;
      this.invalidateChains();
    }
  }
  txRemoveDoc(tx) {
    if (tx.objectClass === import_component.default.class.Attribute) {
      const removeTx = tx;
      const doc = this.findAttributeById(removeTx.objectId);
      if (doc === void 0) return;
      this.attributesById.delete(removeTx.objectId);
      this.externallyOwned.delete(removeTx.objectId);
      this.removed.add(removeTx.objectId);
      const map = this.ownAttributeMap(doc.attributeOf);
      if (map.get(doc.name)?._id === removeTx.objectId) {
        const inherited = this.parent?.ownAttributesOf(doc.attributeOf)?.get(doc.name);
        if (inherited !== void 0 && inherited._id !== doc._id && !this.removed.has(inherited._id)) {
          map.set(doc.name, inherited);
        } else {
          map.delete(doc.name);
        }
      }
    } else if (this.isClassifierTx(tx)) {
      const removeTx = tx;
      if (this.parent?.hasClassifier(removeTx.objectId) === true) this.parentOverridden = true;
      this.classifiers.delete(removeTx.objectId);
      this.externallyOwned.delete(removeTx.objectId);
      this.removed.add(removeTx.objectId);
      this.invalidateChains();
    }
  }
  txMixin(tx) {
    if (this.isClassifierTx(tx)) {
      if (this.externallyOwned.has(tx.objectId)) return;
      const obj = this.ownClassifier(tx.objectId);
      if (obj === void 0) return;
      import_tx.TxProcessor.updateMixin4Doc(obj, tx);
    }
  }
  /** Check if passed _class is derived from `from` class. */
  isDerived(_class, from) {
    const cached = this.ancestors.get(_class);
    if (cached !== void 0) {
      return cached.includes(from);
    }
    return this.hasClassifier(_class) ? this.getAncestors(_class).includes(from) : false;
  }
  /**
   * Return first non interface/mixin parent
   */
  getBaseClass(_class) {
    let cl = _class;
    while (cl !== void 0) {
      const clz = this.getClass(cl);
      if (this.isClass(clz)) return cl;
      cl = clz.extends;
    }
    return import_component.default.class.Doc;
  }
  /**
   * Check if passed _class implements passed interfaces `from`.
   * It will check for class parents and their interfaces.
   */
  isImplements(_class, from) {
    let cl = _class;
    while (cl !== void 0) {
      const klazz = this.getClass(cl);
      if (this.isExtends(klazz.implements ?? [], from)) {
        return true;
      }
      cl = klazz.extends;
    }
    return false;
  }
  /**
   * Check if interface extends passed interface.
   */
  isExtends(extendsOrImplements, from) {
    const result = [];
    const toVisit = [...extendsOrImplements];
    while (toVisit.length > 0) {
      const ref = toVisit.shift();
      if (ref === from) {
        return true;
      }
      addIf(result, ref);
      toVisit.push(...this.ancestorsOf(ref));
    }
    return false;
  }
  /** An unknown classifier simply has no descendants - queries may still reference removed classes. */
  getDescendants(_class) {
    const cached = this.descendants.get(_class);
    if (cached !== void 0) {
      return cached;
    }
    if (!this.hasClassifier(_class)) {
      return [];
    }
    let result;
    if (this.parent !== void 0 && !this.parentOverridden) {
      const inherited = this.parent.getDescendants(_class);
      const own = [];
      for (const id of this.classifiers.keys()) {
        if (!this.parent.hasClassifier(id) && this.getAncestors(id).includes(_class)) own.push(id);
      }
      result = own.length === 0 ? inherited : [...inherited, ...own];
    } else {
      result = [];
      for (const classifier of this.classifierIds()) {
        if (this.getAncestors(classifier).includes(_class)) {
          result.push(classifier);
        }
      }
    }
    this.descendants.set(_class, result);
    return result;
  }
  /**
   * Return extends and implemnets as combined list of references
   */
  ancestorsOf(classifier) {
    const attrs = this.findClassifier(classifier);
    const result = [];
    if (this.isClass(attrs) || this._isMixin(attrs)) {
      const cls = attrs;
      if (cls.extends !== void 0) {
        result.push(cls.extends);
      }
      result.push(...cls.implements ?? []);
    }
    if (this.isInterface(attrs)) {
      result.push(...attrs.extends ?? []);
    }
    return result;
  }
  isClass(attrs) {
    return attrs?.kind === import_classes.ClassifierKind.CLASS;
  }
  _isMixin(attrs) {
    return attrs?.kind === import_classes.ClassifierKind.MIXIN;
  }
  isInterface(attrs) {
    return attrs?.kind === import_classes.ClassifierKind.INTERFACE;
  }
  addAttribute(attribute) {
    this.ownAttributeMap(attribute.attributeOf).set(attribute.name, attribute);
    this.attributesById.set(attribute._id, attribute);
    this.classifierProperties.delete(attribute.attributeOf);
  }
  getAllAttributes(clazz, to, traverse) {
    const result = /* @__PURE__ */ new Map();
    let ancestors = this.getAncestors(clazz);
    if (to !== void 0) {
      const toAncestors = this.getAncestors(to);
      for (const uto of toAncestors) {
        if (ancestors.includes(uto)) {
          to = uto;
          break;
        }
      }
      ancestors = ancestors.filter(
        (c) => c !== to && (this.isInterface(this.findClassifier(c)) || this.isDerived(c, to))
      );
    }
    for (let index = ancestors.length - 1; index >= 0; index--) {
      const cls = ancestors[index];
      const attributes = this.ownAttributesOf(cls);
      if (attributes !== void 0) {
        for (const [name, attr] of attributes) {
          traverse?.(name, attr);
          result.set(name, attr);
        }
      }
    }
    return result;
  }
  getOwnAttributes(clazz) {
    const result = /* @__PURE__ */ new Map();
    const attributes = this.ownAttributesOf(clazz);
    if (attributes !== void 0) {
      for (const [name, attr] of attributes) {
        result.set(name, attr);
      }
    }
    return result;
  }
  getParentClass(_class) {
    const baseDomain = this.getDomain(_class);
    const ancestors = this.getAncestors(_class);
    let result = _class;
    for (const ancestor of ancestors) {
      try {
        const domain = this.getClass(ancestor).domain;
        if (domain === baseDomain) {
          result = ancestor;
        }
      } catch {
      }
    }
    return result;
  }
  getAttribute(classifier, name) {
    const attr = this.findAttribute(classifier, name);
    if (attr === void 0) {
      throw new Error("attribute not found: " + name);
    }
    return attr;
  }
  findAttribute(classifier, name) {
    const list = [classifier];
    const visited = /* @__PURE__ */ new Set();
    while (list.length > 0) {
      const cl = list.shift();
      if (addNew(visited, cl)) {
        const attribute = this.ownAttributesOf(cl)?.get(name);
        if (attribute !== void 0) {
          return attribute;
        }
        list.push(...this.ancestorsOf(cl));
      }
    }
  }
  updateLookupMixin(_class, result, options) {
    const baseClass = this.getBaseClass(_class);
    const vResult = baseClass !== _class ? this.as(result, _class) : result;
    const lookup = result.$lookup;
    if (lookup !== void 0) {
      const lu = options?.lookup;
      if (lu?._id !== void 0) {
        for (const [k, v] of Object.entries(lu._id)) {
          const _cl = getClass(v);
          if (this.isMixin(_cl)) {
            const mval = lookup[k];
            if (mval !== void 0) {
              if (Array.isArray(mval)) {
                ;
                lookup[k] = mval.map((it) => this.as(it, _cl));
              } else {
                ;
                lookup[k] = this.as(mval, _cl);
              }
            }
          }
        }
      }
      for (const [k, v] of Object.entries(lu ?? {})) {
        if (k === "_id") {
          continue;
        }
        const _cl = getClass(v);
        if (this.isMixin(_cl)) {
          const mval = lookup[k];
          if (mval != null) {
            ;
            lookup[k] = this.as(mval, _cl);
          }
        }
      }
    }
    return vResult;
  }
  clone(obj) {
    return (0, import_clone.clone)(
      obj,
      (doc, m) => this.as(doc, m),
      (value) => Hierarchy.mixinClass(value)
    );
  }
  domains() {
    const classes = Array.from(this.classifierIds(), (_id) => this.findClassifier(_id)).filter(
      (it) => it !== void 0 && (this.isClass(it) || this._isMixin(it))
    );
    return classes.map((it) => it.domain).filter((it) => it !== void 0).filter((it, idx, array) => array.findIndex((pt) => pt === it) === idx);
  }
  getClassifierProp(cl, prop) {
    return this.classifierProperties.get(cl)?.get(prop);
  }
  setClassifierProp(cl, prop, value) {
    let cur = this.classifierProperties.get(cl);
    if (cur === void 0) {
      cur = /* @__PURE__ */ new Map();
      this.classifierProperties.set(cl, cur);
    }
    cur.set(prop, value);
  }
}
const CLASSIFIER_CLASSES = [import_component.default.class.Class, import_component.default.class.Mixin, import_component.default.class.Interface];
function addNew(val, value) {
  if (val.has(value)) {
    return false;
  }
  val.add(value);
  return true;
}
__name(addNew, "addNew");
function addIf(array, value) {
  if (!array.includes(value)) {
    array.push(value);
  }
}
__name(addIf, "addIf");
function getClass(vvv) {
  if (Array.isArray(vvv)) {
    return vvv[0];
  }
  return vvv;
}
__name(getClass, "getClass");
//# sourceMappingURL=hierarchy.js.map
